import { Fragment } from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import remarkBreaks from 'remark-breaks';

import { capitalizeFirstLetter } from '@lib/core/service/utils';

type Props = Omit<Options, 'children'> & {
  text: string | number | JSX.Element;
  transformText?: 'default' | 'none' | 'custom-pmi' | 'lowercase' | 'markdown';
};

const CustomMDReactComponent = ({ text = '', transformText = 'default', ...rest }: Props) => {
  const transformedText = (() => {
    const textStr = String(text);

    let modifiedText = transformText === 'default' ? capitalizeFirstLetter(textStr) : textStr;

    if (modifiedText.includes('||') || transformText === 'custom-pmi') {
      // meglio: \n basta con remark-breaks
      modifiedText = modifiedText.replace(/\|\|/g, '\n\u00A0\n'); // riga vuota che NON collassa
    }

    return modifiedText;
  })();

  const components: Options['components'] = {
    a: props => (
      <a {...props} rel="noopener noreferrer" target="_blank">
        {props.children}
      </a>
    ),

    hr:
      transformText === 'markdown'
        ? props => <hr style={{ margin: '24px 0' }} {...props} />
        : props => <hr {...props} />,

    p: transformText === 'markdown' ? ({ children }) => <p style={{ margin: '0 0 12px 0' }}>{children}</p> : Fragment,

    ul:
      transformText === 'markdown' ? ({ children }) => <ul style={{ margin: '0 0 12px 0' }}>{children}</ul> : Fragment,
  };

  return (
    <ReactMarkdown components={components} remarkPlugins={[remarkBreaks]} {...rest}>
      {transformedText}
    </ReactMarkdown>
  );
};

export default CustomMDReactComponent;
